import React from "react";
import { useQuery } from "@apollo/client";
import TeamTable from "../../Components/Team/TeamTable.js";
import { GET_TEAMS, TEAMS_WITH_PERMISSION } from "../../GraphQL/Teams";
import { GET_MANAGERS } from "../../GraphQL/Managers";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";

const TeamsPage = () => {
  const teams = useQuery(GET_TEAMS, {});
  const managers = useQuery(GET_MANAGERS, {});
  const teamsWithPermission = useQuery(TEAMS_WITH_PERMISSION, {});

  const queryError = teams.error || managers.error || teamsWithPermission.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          teams.refetch();
          managers.refetch();
          teamsWithPermission.refetch();
        }}
      />
    );
  }

  if (teams.loading || managers.loading || teamsWithPermission.loading)
    return <LoadingSpinner />;

  return (
    <PageLayout
      title="Teams"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Teams" }]}
    >
      <TeamTable
        managers={managers.data.managers}
        teams={teams.data.teams}
        teamsWithPermission={teamsWithPermission.data.teamsWithPermission}
      />
    </PageLayout>
  );
};

export default TeamsPage;
